import { render, staticRenderFns } from "./kanban.vue?vue&type=template&id=32046268&scoped=true&"
import script from "./kanban.vue?vue&type=script&lang=js&"
export * from "./kanban.vue?vue&type=script&lang=js&"
import style0 from "./kanban.vue?vue&type=style&index=0&id=32046268&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32046268",
  null
  
)

export default component.exports